
import { Link } from 'react-router-dom';

export default function ContactCTA() {
  return (
    <section className="bg-[#1A1A1A] text-white py-16 md:py-20 px-4 md:px-8">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="font-['Montserrat'] font-bold text-2xl md:text-3xl lg:text-4xl mb-6">
          Need Help Choosing the Right Product?
        </h2>
        <p className="text-base md:text-lg text-gray-300 mb-8 md:mb-10">
          Our team of experts is ready to help you select the perfect materials for your project.
        </p>
        <div className="flex flex-col md:flex-row gap-4 justify-center">
          <Link
            to="/contact"
            className="w-full md:w-auto bg-[#F2C612] text-[#1A1A1A] font-['Montserrat'] font-semibold px-8 py-3 rounded-lg hover:bg-[#d4ad0a] transition-colors whitespace-nowrap cursor-pointer min-h-[48px] flex items-center justify-center"
          >
            Contact Us
          </Link>
          <Link
            to="/learn"
            className="w-full md:w-auto bg-transparent border-2 border-white text-white font-['Montserrat'] font-semibold px-8 py-3 rounded-lg hover:bg-white hover:text-[#1A1A1A] transition-colors whitespace-nowrap cursor-pointer min-h-[48px] flex items-center justify-center"
          >
            Watch Tutorials
          </Link>
        </div>
      </div>
    </section>
  );
}
